import Svg, { SvgProps, Path } from 'react-native-svg';

const TeamIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 30 30" width={30} height={30} fill="#FFFFFF" {...props}>
    <Path d="M9.441 3c-5.45.094-6.008 3.874-4.914 8.215-.212.122-.56.51-.472 1.197.164 1.283.72 1.608 1.074 1.635C5.264 15.245 6.55 16.777 7 17v2c-1 3-7 0-7 8h12c0-3.548 1.99-5.076 3.648-5.955C14.09 20.499 12.477 20.43 12 19v-2c.45-.223 1.735-1.754 1.871-2.951.08-.283.143-1.296.143-1.524 0-1.249-.019-3.83.763-5.851-.273-1.358-.986-2.503-2.515-2.654-.41-.677-1.458-1.02-2.82-1.02zm12.682 1c-1.124 0-1.992 1-1.992 1-6.442 0-2.866 10.953-4.758 12.527 0 0 1.006 1.49 4.627 1.49v1.276C19 23 14 22 14 27h16c0-5-5-4-6-6.707v-1.287c3.639 0 4.482-1.442 4.482-1.442C26.445 15.892 30 4 22.123 4z" />
  </Svg>
);

export default TeamIcon;
